/**
 * ErrorPage — generic friendly error landing.
 */

interface Props {
  reason?: string;
  navigate: (path: string) => void;
}

const REASONS: Record<string, string> = {
  invalid_or_expired: "That link's expired or already used. Get a new one below.",
  session_missing: "You've been signed out. Sign back in below.",
};

export default function ErrorPage({ reason, navigate }: Props) {
  const message =
    (reason && REASONS[reason]) || 'Something went wrong. Try signing in below.';

  return (
    <div className="bg-white dark:bg-slate-900 rounded-lg shadow-sm border border-slate-200 dark:border-slate-800 p-8 text-center max-w-lg mx-auto">
      <div className="w-16 h-16 bg-amber-100 dark:bg-amber-900/40 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg className="w-8 h-8 text-amber-600 dark:text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      </div>
      <h1 className="text-xl font-semibold text-slate-900 dark:text-white mb-2">
        Hmm &mdash; that didn't work
      </h1>
      <p className="text-slate-600 dark:text-slate-300 mb-6">{message}</p>
      <button
        onClick={() => navigate('/portal/login')}
        className="px-4 py-2 bg-blue-600 dark:bg-blue-500 text-white rounded-md hover:bg-blue-700 dark:hover:bg-blue-600"
      >
        Get a new link
      </button>
    </div>
  );
}
